import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
    selector: 'app-agaia-mobile-app-banner',
    templateUrl: './agaia-mobile-app-banner.component.html',
    styleUrls: ['./agaia-mobile-app-banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgaiaMobileAppBannerComponent {
    /** `inline` — meals; `hero` — /mobile-app landing */
    @Input() variant: 'inline' | 'hero' = 'inline';

    readonly phoneSrc = 'assets/images/banners/agaia-mobile-app-banner-phone.png';
    readonly iosAppUrl = 'https://apps.apple.com/app/agaia-life/id1589104436';
    readonly androidAppUrl = 'https://play.google.com/store/apps/details?id=life.agaia.app';
}
